import Grid from "@mui/material/Grid";
import { useAppServices } from "hook/services";
// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import SoftUITabs from "./SoftUITabs/SoftUITabs";
import { useParams } from "react-router-dom";
import { useAgencyInfo } from "context/agency";
import ContactTab from "../Accounts/components/Tabs/ContactTab";
import Business from "../Accounts/components/Tabs/Business";
import Events from "./components/Tabs/Events";
import AccountTab from "../Accounts/components/Tabs/AccountTab";
import CustomTabs from "../components/CustomTabs";

function AccountDetail() {
  const [agency] = useAgencyInfo();
  const { id } = useParams(); // Extract the ID from the URL
  const navigate = useNavigate();
  const AppService = useAppServices();
  const [formData, setformData] = useState({});

  const onLoad = async () => {
    const url = window.location.href;
    const parts = url.split("/"); // Split the URL by '/'
    const lastPart = parts[parts.length - 1]; // Get the last part of the URL
    const { response } = await AppService.accounts.getbyid({
      query: `id=${lastPart}`,
    });
    if (response) {
      setformData(response.data);
    }
  };
  useEffect(() => {
    onLoad();
  }, []);
  let tabsData = [
    {
      label: "Personal Details",
      content: <ContactTab handleRefresh={onLoad} formData={formData} />,
    },
    { label: "Followed Business", content: <AccountTab data={agency} /> },
    { label: "Events", content: <Events handleRefresh={onLoad} formData={formData} /> },
  ];
  return (
    <PageLayout>
      <SoftBox style={{ margin: "10px 20px" }} pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <h1 className="headingpage-branding">Consumers</h1>
            <span style={{ fontSize: "14px", cursor: "pointer" }} onClick={() => navigate(-1)}>
              {" "}
              {"Consumer"} {`>`}
            </span>{" "}
            <span style={{ fontSize: "14px" }}> {formData.business_name}</span>
            <h1 className=" my-3percent headingpage-branding">
              {formData.business_name}{" "}
              <span className="alert-success-new">
                {formData?.type === "premium" ? formData?.type : "Free"}
              </span>
            </h1>
            <CustomTabs tabsData={tabsData} />
          </Grid>
        </Grid>
      </SoftBox>
    </PageLayout>
  );
}

export default AccountDetail;
